import { render, staticRenderFns } from "./GoalsPerSeller.vue?vue&type=template&id=6cba62cc&"
import script from "./GoalsPerSeller.vue?vue&type=script&lang=js&"
export * from "./GoalsPerSeller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports